import React from "react";

import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";

import useStyles from "./styles";

interface Props {
  dataCy?: string;
  accordionTitle: string;
  children: React.ReactChild;
  expand?: boolean;
  onClick?: () => void;
}

const UIAccordion = ({ expand, onClick, accordionTitle, dataCy, children }: Props) => {
  const classes = useStyles({
    borderRadius: expand ? "8px 8px 0 0" : "8px",
  })();

  return (
    <Accordion expanded={expand} data-cy={dataCy} className={classes.accordionWrapper}>
      <AccordionSummary
        className={classes.accordionSummary}
        expandIcon={<MdOutlineKeyboardArrowDown />}
        onClick={onClick}
      >
        <span>{accordionTitle}</span>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>{children}</AccordionDetails>
    </Accordion>
  );
};

export default UIAccordion;
